import styled from "styled-components";

const Input = styled.input`
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 15px 15px;
  max-height: 18px;
  font-size: 13px;
  @media(max-width: 480px) {
    width: calc(100% - 32px);
  }
`;

export default Input;